import styled from 'styled-components';
import Actions from 'components/Shared/Forms/Actions';
import { StyledLabel } from 'components/Shared/Forms/styles';

export const StyledActions = styled(Actions)`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const StyledLabelInformation = styled(StyledLabel)`
    align-items: flex-start;
    .ant-form-item-control-input-content{
        display: flex;
        flex-direction: row;
        .name{
            margin-left: 2px;
        }
    }
`;
